module.exports = __webpack_public_path__ + "static/media/60.11a66e26.jpg";